import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, Http, Headers, RequestOptions } from '@angular/http';
import { DatePipe } from '@angular/common';
import { AuthHttp, provideAuth, AuthConfig } from 'angular2-jwt';
import { ActiveRouteHeaderService } from './_services/active-route-header.service';
import { NgxPermissionsModule } from 'ngx-permissions';
// used to create fake backend
import { fakeBackendProvider, Helper } from './_helpers/index';
import { MockBackend, MockConnection } from '@angular/http/testing';
import { BaseRequestOptions } from '@angular/http';
import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { AlertComponent } from './_directives/index';
import { AuthGuard } from './_guards/index';
import { AlertService, AuthenticationService, UserService } from './_services/index';
import { HomeComponent } from './home/index';
import { LoginComponent } from './login/index';
import { RegisterComponent } from './register/index';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ReservationComponent } from './reservation/reservation.component';
import { CreditesComponent } from './credites/credites.component';
import { ProfilesComponent } from './profiles/profiles.component';
import { RefProgramComponent } from './ref-program/ref-program.component';
import { UserfeedbackComponent } from './userfeedback/userfeedback.component';
//import { Angular2SocialLoginModule } from "angular2-social-login";
import { FacebookModule } from 'ng2-facebook-sdk';
import { WizardComponent } from './wizard/wizard.component';
// import { PromotionviewComponent } from './promotionview/promotionview.component';
import { Ng2UploaderModule } from 'ng2-uploader';
import { BranchNameComponent } from './branchname/branchname.component';
import { AddressComponent } from './address/address.component';
import { BussinesshoursComponent } from './bussinesshours/bussinesshours.component';
import { WifidetailsComponent } from './wifidetails/wifidetails.component';
import { ContactdetailsComponent } from './contactdetail/contactdetail.component';
import { BranchscancodeComponent } from './branchscancode/branchscancode.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ViewreservationComponent } from './viewreservation/viewreservation.component';
import { JsonUpdateComponent } from './jsonupdate/jsonupdate.component';
import { MettingRoomServices } from './_services/metting-room.service';
import { ManagePermissionsServices } from './_services/managepermissions.service';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive/src';
import { GlobalModule } from './global/global.module';
import { PaymentServices } from './_services/payment.services';
import { OrdersReportServices } from './_services/ordersreport.service';
import { PurchasePointsMessagesServices } from './_services/purchasepointsmessages.service';
import { PurchasePointsSettingsServices } from './_services/purchasepointssettings.service';
import { RestManageUserServices } from './_services/restmanageusers.service';
import { ManageTablesServices } from './_services/managetables.service';
import { DeliveryPartnersServices } from './_services/deliverypartners.service';
import { ManageAgentServices } from './_services/manageagent.service';
import { GenerateCouponServices } from './_services/generatecp.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {ToastModule} from 'ng2-toastr/ng2-toastr';
import {ToastOptions} from 'ng2-toastr';
import { DiagnosisComponent } from './diagnosis/diagnosis.component';
import { SharedModule } from './shared.module';
import { ProfilesV1Component } from './profiles-v1/profiles-v1.component';
// import { SafePipe } from './safe.pipe';
export class CustomOption extends ToastOptions {
  positionClass: 'toast-bottom-full-width';
  animate = 'flyRight'; // you can override any options available
  showCloseButton = true;
  toastLife= 3000;
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function getAuthHttp(http: Http) {
  return new AuthHttp(new AuthConfig({
    headerName: 'x-auth-token',
    noTokenScheme: true,
    noJwtError: true,
    globalHeaders: [{ 'Accept': 'application/json' }],
    tokenGetter: (() => (localStorage.getItem('id_token') != null) ? localStorage.getItem('id_token') : localStorage.getItem('login_token')),
  }), http);
}

export function getAuthHttpWithActiveRoute(http: Http, activeRouteHeaderService: ActiveRouteHeaderService) {
  const authHttp = new AuthHttp(new AuthConfig({
    headerName: 'x-auth-token',
    noTokenScheme: true,
    noJwtError: true,
    globalHeaders: [{ 'Accept': 'application/json' }],
    tokenGetter: (() => (localStorage.getItem('id_token') != null) ? localStorage.getItem('id_token') : localStorage.getItem('login_token')),
  }), http);

  const originalRequest = (authHttp as any).request.bind(authHttp);
  (authHttp as any).request = (url: any, options?: any) => {
    const activeRoute = activeRouteHeaderService.getActiveRoute();
    const headers: Headers = options && options.headers ? options.headers : new Headers();
    try {
      headers.set('X-Active-Route', activeRoute);
    } catch (e) {
      // ignore header set failure
    }
    const merged: RequestOptions = new RequestOptions(Object.assign({}, options, { headers }));
    return originalRequest(url, merged);
  };

  return authHttp;
}

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    routing,
    Ng2UploaderModule,
    NgxTrimDirectiveModule,
    GlobalModule,
    //Angular2SocialLoginModule,
    FacebookModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    ToastModule.forRoot(),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }) ,
    SharedModule 
    ],
    declarations: [
        AppComponent,
        AlertComponent,
        HomeComponent,
        LoginComponent,
        RegisterComponent,
        DashboardComponent,
        ReservationComponent,
        CreditesComponent,
        ProfilesComponent,
        RefProgramComponent,
        UserfeedbackComponent,
        WizardComponent,
        BranchNameComponent,
        AddressComponent,
        BussinesshoursComponent,
        WifidetailsComponent,
        ContactdetailsComponent,
        BranchscancodeComponent,
        ViewreservationComponent,
        JsonUpdateComponent,
        DiagnosisComponent,
        ProfilesV1Component
        // SafePipe,
    ],
    providers: [
        AuthHttp,
        AuthGuard,
        AlertService,
        AuthenticationService,
        UserService,
        ActiveRouteHeaderService,
        MettingRoomServices,
        ManagePermissionsServices,
        PaymentServices,
        DatePipe,
        OrdersReportServices,
        PurchasePointsMessagesServices,
        PurchasePointsSettingsServices,
        RestManageUserServices,
        ManageTablesServices,
        DeliveryPartnersServices,
        ManageAgentServices,
        GenerateCouponServices,
        // providers used to create fake backend
        fakeBackendProvider,
        MockBackend,
        BaseRequestOptions,
         {provide: ToastOptions, useClass: CustomOption},
        Helper,
        {
          provide: AuthHttp,
          useFactory: getAuthHttpWithActiveRoute,
          deps: [Http, ActiveRouteHeaderService]
        }
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor() {}
}

//Angular2SocialLoginModule.loadProvidersScripts(providers);





// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/app.module.ts